const conditionTypes = {
  AND: 'AND',
  OR: 'OR'
};

export default conditionTypes;